import React from "react";
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import {CSSTransition} from 'react-transition-group';
import Recaptcha from 'react-google-recaptcha';


var Api = require('../../utils/Api');

const mailregexp = new RegExp('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])');

class Order extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            showThanks: false,
            animate: false,
            Name: '',
            activeName: false,
            Phone: '',
            activePhone: false,
            Email: '',
            activeEmail: false,
            askMessage: '',
            activeaskMessage: false,
            recaptchaValue: '',
            recaptchaStatus: false,
            formSendStatus: false
        }

        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
    }

    onRecaptchaChange(value) {
      if(value)
        this.setState({
            recaptchaStatus: false,
            recaptchaValue: value
        });
    }

    openPopup() {
        this.setState({
            showPopup: true
        });

        setTimeout(() => {
            this.setState({animate: true});
        }, 500);
    }

    closePopup() {
        this.setState({
            Name: '',
            activeName: false,
            Phone: '',
            activePhone: false,
            Email: '',
            activeEmail: false,
            askMessage: '',
            activeaskMessage: false,
            showPopup: false,
            animate: false,
        });
    }

    handleBlur(event) {
        let name = event.target.name;
        let activeEl = 'active' + name;
        let value = event.target.value;
        if (name === 'Phone' && this.state.Phone.match(/\d/g).length < 11) {
            this.setState({
                Phone: '',
                activePhone: false
            });
        }
        if (value === '') {
            this.setState({
                [activeEl]: false
            });
        }
    }

    handleFocus(event) {
        let name = event.target.name;
        let activeEl = 'active' + name;
        this.setState({
            [activeEl]: true
        });
    }

    handleInputChange(event) {
        let value = event.target.value;
        let name = event.target.name;
        this.setState({
            [name]: value
        });
    }

    handleButtonClick(event) {
        event.preventDefault();

        if (this.state.Name === '') {
            this.nameInput.focus();
        } else if (this.state.Phone === '') {
            this.phoneInput.focus();
        } else if (this.state.Email === '' || !mailregexp.test(this.state.Email)) {
            this.emailInput.focus();
        } else if (this.state.askMessage === '') {
            this.askInput.focus();
        } else if (this.state.recaptchaValue === '') {
          this.setState({
              recaptchaStatus: true
          });
        } else {
            let data = {
                emailForZendesk: this.state.Email,
                textForZendesk: this.state.askMessage,
                nameForZendesk: this.state.Name,
                phoneForZendesk: this.state.Phone,
                recaptchaValue: this.state.recaptchaValue
            };
            Api.sendEmail(data)
                .then(function (response) {
                    //console.log(response);
                });

            this.setState({
                Name: '',
                activeName: false,
                Phone: '',
                activePhone: false,
                Email: '',
                activeEmail: false,
                askMessage: '',
                activeaskMessage: false,
                showThanks: true,
                formSendStatus: true
            });
            setTimeout(() => {
              this.captcha.reset();
              this.setState({
                  showPopup: false,
                  formSendStatus: false,
                  recaptchaValue: '',
              });
            }, 2000);
        }

    }

    render() {
        let overlay = classNames({
            'overlay js-overlay': true,
            '_show': this.state.showPopup,
            '_animate': this.state.showPopup
        });
        let popup = classNames({
            'popup container': true,
            '_show': this.state.showPopup,
            '_animate': this.state.animate
        });
        let inputNameClass = classNames({
            'input-style__input': true,
            '_active': this.state.activeName,
        });
        let inputPhoneClass = classNames({
            'input-style__input': true,
            '_active': this.state.activePhone,
        });
        let inputEmailClass = classNames({
            'input-style__input': true,
            '_active': this.state.activeEmail,
        });
        let inputAskClass = classNames({
            'input-style__input': true,
            '_active': this.state.activeaskMessage,
        });
        return (
            <div className="wrapper">
                <div className="main">
                    <div className="offer">
                        <div className="order">
                            <div className="container">
                                <div className="order__block">
                                    <div className="order__title-block">
                                        <h1 className="order__title">Современные средства сбора и обработки данных
                                        </h1>
                                        <div className="btn btnfos btnfos-1 js-open-popup" data-popup="callback"
                                             onClick={this.openPopup}>
                                            <svg>
                                                <rect x="0" y="0" rx="20" ry="20" fill="none"
                                                      width="100%" height="100%"/>
                                            </svg>
                                            Заказать консультацию
                                        </div>
                                    </div>
                                    <img className="order__img" src="images/order_img.png" alt="Order"
                                         title="Order"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={overlay}>
                    <div className="overlay__bg overlay__bg_left">
                    </div>
                    <div className="overlay__bg overlay__bg_right">
                    </div>
                </div>
                <div className={popup} data-id="callback">
                    <div className="popup__wrapper">
                        <img className="popup__close" src="images/close.png" alt=""
                             role="presentation" onClick={this.closePopup}/>
                        <div className="popup__content js-scrollbar-instant">
                            <section className="form-wrap block-wrapper">
                                <div className="container">
                                    <div className="form-wrap__contact-block">
                                        <form className="form" action='/'>
                                            <h2 className="form__title">Мы на связи
                                            </h2>
                                            <p className="form__text">Заполните форму ниже для связи с нами
                                            </p>
                                            <div className="form__row form__row_3-col">
                                                <div className="form__col">
                                                    <div className="input-style input-style_require-icon">
                                                        <input className={inputNameClass}
                                                               type="text" name="Name" data-title="Ваше имя"
                                                               id="middle-name" value={this.state.Name}
                                                               ref={(input) => {
                                                                   this.nameInput = input;
                                                               }}
                                                               onChange={this.handleInputChange}
                                                               onFocus={this.handleFocus} onBlur={this.handleBlur}/>
                                                        <label className="input-style__label" htmlFor="middle-name">
                                                        </label>
                                                        <div className="input-style__placeholder">Ваше имя
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form__col">
                                                    <div className="input-style input-style_require-icon">
                                                        <InputMask mask="+7 (999) 999-99-99" className={inputPhoneClass}
                                                                   type="text" name="Phone" data-title="Телефон"
                                                                   id="phone" value={this.state.Phone}
                                                                   inputRef={(input) => {
                                                                       this.phoneInput = input;
                                                                   }}
                                                                   onChange={this.handleInputChange}
                                                                   onFocus={this.handleFocus} onBlur={this.handleBlur}/>
                                                        <label className="input-style__label" htmlFor="phone">
                                                        </label>
                                                        <div className="input-style__placeholder">Телефон
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form__col">
                                                    <div className="input-style input-style_require-icon">
                                                        <input className={inputEmailClass}
                                                               type="text" name="Email" data-title="E-mail"
                                                               id="e-mail" value={this.state.Email}
                                                               ref={(input) => {
                                                                   this.emailInput = input;
                                                               }}
                                                               onChange={this.handleInputChange}
                                                               onFocus={this.handleFocus} onBlur={this.handleBlur}/>
                                                        <label className="input-style__label" htmlFor="e-mail">
                                                        </label>
                                                        <div className="input-style__placeholder">E-mail
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input-style input-style_require-icon">
                                                <input className={inputAskClass} type="text" name="askMessage"
                                                       data-title="Ваш вопрос" id="ask" value={this.state.askMessage}
                                                       ref={(input) => {
                                                           this.askInput = input;
                                                       }}
                                                       onChange={this.handleInputChange}
                                                       onFocus={this.handleFocus} onBlur={this.handleBlur}/>
                                                <label className="input-style__label" htmlFor="ask">
                                                </label>
                                                <div className="input-style__placeholder">Ваш вопрос
                                                </div>
                                            </div>
                                            <p className="form__require-mark"> *
                                                <span
                                                    className="form__require-text">- поля обязательные для заполнения</span>
                                            </p>
                                            <div className="btn-row">
                                                {!this.state.formSendStatus &&
                                                <button className="btn-style btn-style_fill btn-style_enter"
                                                        onClick={this.handleButtonClick}>
                                                    <span className="btn-style__text">Отправить</span>
                                                </button>}
                                                {this.state.formSendStatus &&
                                                <div className="form__alert alert-success" role="alert">Ваше сообщение
                                                    отправлено.</div>}
                                            </div>
                                            <div className="form__captcha">
                                                <Recaptcha
                                                    ref={e => (this.captcha = e)}
                                                    sitekey="6LeB_VIUAAAAAAfxkCl_MKUaCxu7uPs2Kw7C5qKO"
                                                    onChange={this.onRecaptchaChange}
                                                />
                                                {this.state.recaptchaStatus &&
                                                <div className="form__alert alert-danger" role='alert'>Заполните reCAPTCHA!</div>}
                                                <div className="form__captcha-text">Нажимая кнопку «Отправить» вы соглашаетесь на
                                                    обработку персональных данных
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <CSSTransition
                                    in={this.state.showThanks}
                                    timeout={300}
                                    classNames="message"
                                    unmountOnExit
                                >
                                    {state => (
                                        <div className="access-block">
                                            <div className="container">
                                                <div className="access">
                                                    <div className="access__text">
                                                        <div className="access__thanks">Спасибо!
                                                        </div>
                                                        <div className="access__send">Ваша заявка отправлена
                                                        </div>
                                                        <div className="access__wait">Как только мы ее обработаем, с
                                                            вами
                                                            свяжутся.
                                                            <br/>Обычно это занимает 15 минут!
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </CSSTransition>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Order;


// WEBPACK FOOTER //
// ./src/Components/MainPage/Order.js